import type { PreparedSeries } from "./prepare-series";

export function PanelLegend({ series }: { series: PreparedSeries[] }) {
    if (series.length === 0) return null;

    return (
        <div className={"flex min-w-0 flex-wrap items-center justify-center gap-x-3 gap-y-0.5 pt-1 ml-[42px]"}>
            {series.map((s) => (
                <div key={String(s.streamId)} className={"flex min-w-0 items-center gap-1.5"}>
                    <span
                        aria-hidden
                        className={"inline-block h-1 w-4 shrink-0 rounded-full"}
                        style={{ backgroundColor: s.color }}
                    />
                    <span className={"truncate text-sm text-muted-foreground"}>{s.name}</span>
                </div>
            ))}
        </div>
    );
}
